import TickText from '../Axis/TickText';
import { XAxis } from '../Axis/XAxis';
import { useTheme } from '@gogame/ui/styles';

export const AnnotationTick = ({
  onSelect,
  data,
  hoveredCategory,
  selectedCategory,
  highlightingStart,
  ...props
}) => {
  const theme = useTheme();
  const { x, y, payload, dataKey } = props;

  const { value } = payload;
  const categoryData = data[value];
  const annotations = (categoryData && categoryData[dataKey]) || [];

  const count = annotations.length;

  const active = [
    selectedCategory,
    hoveredCategory,
    highlightingStart,
  ].includes(value);

  const handleClick = () => {
    onSelect({ value, annotations });
  };

  if (!count) {
    return null;
  }

  return (
    <g
      style={{ cursor: 'pointer' }}
      onClick={handleClick}
      // id={active ? `active-annotation` : undefined}
    >
      <path
        fill={
          active ? theme.palette.secondary.main : theme.palette.background.paper
        }
        transform={`translate(${x - 11},${y - 13})`}
        d={
          'M 22.5 11.5 A 11 11 0 1 1 22.499994500000458 11.489000001833327 Z M 11.5 22.5 L 11.5 30'
        }
        stroke={theme.palette.primary.main}
        strokeWidth={'3'}
      ></path>
      <TickText x={x} y={y + 2} textAnchor={'middle'}>
        {count}
      </TickText>
    </g>
  );
};

export class Annotations extends XAxis {
  static xAxisName = 'Annotations';
  static defaultProps = {
    ...XAxis.defaultProps,
    mirror: true,
    xAxisId: 'annotations',
    dataKey: 'category',
    allowDuplicatedCategory: false,
    minTickGap: 1,
    interval: 0,
  };
}
